import cartAddOns from './cartAddOns/cartAddOns';
import cartHeader from './cartHeader/cartHeader';
import cartList from './cartList/cartList';
import cartModel from './cart/cartModel';
import cartTotals from './cartTotals/cartTotals';
import faq from './faq/faq';
import featuredProducts from './featuredProducts/featuredProducts';
import footer from './footer/footer';
import funnelHeader from './funnelHeader/funnelHeader';
import head from './head/head';
import header from './header/header';
import headerPromo from './headerPromo/headerPromo';
import hero from './hero/hero';
import journalModule from './journalModule/journalModule';
import kitHero from './kitHero/kitHero';
import kitModule from './kitModule/kitModule';
import kitPromo from './kitPromo/kitPromo';
import kitTestimonials from './kitTestimonials/kitTestimonials';
import mlpHero from './mlpHero/mlpHero';
import mlpFeaturedIn from './mlpFeaturedIn/mlpFeaturedIn';
import mlpFeatures from './mlpFeatures/mlpFeatures';
import mlpFeaturesTwo from './mlpFeaturesTwo/mlpFeaturesTwo';
import mlpPlans from './mlpPlans/mlpPlans';
import mlpUgcImages from './mlpUgcImages/mlpUgcImages';
import mlpReview from './mlpReview/mlpReview';
import mlpNav from './mlpNav/mlpNav';
import mlpStarted from './mlpStarted/mlpStarted';
import learnMore from './learnMore/learnMore';
import modal from './modal/modal';
import newsletterModal from './newsletterModal/newsletterModal';
import plpHero from './plpHero/plpHero';
import posts from './posts/posts';
import press from './press/press';
import productBenefits from './productBenefits/productBenefits';
import productTechnology from './productTechnology/productTechnology';
import productUgcImages from './productUgcImages/productUgcImages';
import productFeaturedIn from './productFeaturedIn/productFeaturedIn';
import productQuizTable from './productQuizTable/productQuizTable';
import productFit from './productFit/productFit';
import productGallery from './productGallery/productGallery';
import productIngredients from './productIngredients/productIngredients';
import productInfo from './productInfo/productInfo';
import productReviews from './productReviews/productReviews';
import productTile from './productTile/productTile';
import promoTile from './promoTile/promoTile';
import sizes from './sizes/sizes';
import supportContent from './supportContent/supportContent';
import supportHero from './supportHero/supportHero';
import swatches from './swatches/swatches';
import testimonials from './testimonials/testimonials';
import tiles from './tiles/tiles';
import stickyAddToCart from './stickyAddToCart/stickyAddToCart'

export {
  cartAddOns,
  cartHeader,
  cartList,
  cartModel,
  cartTotals,
  faq,
  featuredProducts,
  footer,
  funnelHeader,
  head,
  header,
  headerPromo,
  hero,
  journalModule,
  kitHero,
  kitModule,
  kitPromo,
  kitTestimonials,
  mlpHero,
  mlpFeaturedIn,
  mlpFeatures,
  mlpFeaturesTwo,
  mlpPlans,
  mlpUgcImages,
  mlpReview,
  mlpNav,
  mlpStarted,
  learnMore,
  modal,
  newsletterModal,
  plpHero,
  posts,
  press,
  productBenefits,
  productTechnology,
  productUgcImages,
  productFeaturedIn,
  productQuizTable,
  productFit,
  productGallery,
  productInfo,
  productIngredients,
  productReviews,
  productTile,
  promoTile,
  sizes,
  supportContent,
  supportHero,
  swatches,
  testimonials,
  tiles,
  stickyAddToCart
};
